import { Link } from '@/components'
import {
  getCourtoisPrivacyUrl,
  getCourtoisSecurityUrl,
  getCourtoisSubprocessorsUrl,
  getCourtoisTermsUrl,
} from '@/services/courtois'

const LEGAL_LINKS = [
  { label: 'Privacy', href: getCourtoisPrivacyUrl() },
  { label: 'Terms', href: getCourtoisTermsUrl() },
  { label: 'Security', href: getCourtoisSecurityUrl() },
  { label: 'Subprocessors', href: getCourtoisSubprocessorsUrl() },
]

const CORPORATE_ADDRESS = '167 Madison Avenue, Ste 205 #335, New York, NY 10016'

export const LegalFooter = () => (
  <footer className="relative z-10 mx-auto mt-12 w-full max-w-5xl xl:max-w-6xl">
    <div className="flex flex-col items-center gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:justify-between">
      <p>
        © {new Date().getFullYear()} CounselPro, Inc.
        {CORPORATE_ADDRESS && (
          <span className="text-muted-foreground"> · {CORPORATE_ADDRESS}</span>
        )}
      </p>

      <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        {LEGAL_LINKS.map(({ label, href }) => (
          <Link
            key={label}
            href={href}
            newTab
            className="text-muted-foreground hover:text-foreground"
          >
            {label}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
)
